import { get, merge } from 'lodash';
import flat from 'flat';
import appConfig from 'Config';
import {
  EVENT_GA,
  CONNECTION_STATUS_LOGGED,
  CONNECTION_STATUS_QUICK_LOGGED,
  CONNECTION_STATUS_NOT_LOGGED,
  BE_TRACKING,
} from 'Tracking/constants';
import * as googleDataLayer from 'Tracking/data-layer-google';
import * as trackingStorageApi from 'Tracking/tracking-storage-api';
import { invariant } from 'Utils/invariant/invariant';
const SITE_B2C = 'B2C';
const SITE_B2B = 'B2B';

function replaceUndefinedWithNull(data) {
  const flatten = flat(data);
  return flat.unflatten(
    Object.keys(flatten).reduce((acc, key) => {
      acc[key] = flatten[key] === undefined ? null : flatten[key];
      return acc;
    }, {}),
  );
}

function getCommonDataLayer(data, appContext, categoryId) {
  return {
    categoryGA: categoryId || 'not_set',
    locale: appContext.locale,
    event: EVENT_GA,
    valueGA: 0,
    nonInteraction: 0,
    ...data,
  };
}

export function userStatus(appContext: AppContext) {
  if (appContext.isSeller) {
    return appContext.isSellerLogged ? CONNECTION_STATUS_LOGGED : CONNECTION_STATUS_NOT_LOGGED;
  }

  if (appContext.isUserQuickLogged) {
    return CONNECTION_STATUS_QUICK_LOGGED;
  }

  return appContext.isUserLogged ? CONNECTION_STATUS_LOGGED : CONNECTION_STATUS_NOT_LOGGED;
}
export function reset() {
  googleDataLayer.reset();
}
export function getDataLayer() {
  return {
    google: googleDataLayer.getDataLayer(),
  };
}
export function setDataLayer(data: any, appContext: AppContext, categoryId?: string) {
  data = data || {};
  invariant(appContext, 'The function setDataLayer needs the appContext data.');
  invariant(data.categoryGA || categoryId, 'The function setDataLayer needs a categoryId.');

  if (appContext) {
    const commonDataLayer = getCommonDataLayer(data, appContext, categoryId);
    const cookie = trackingStorageApi.get(BE_TRACKING);
    googleDataLayer.set(
      replaceUndefinedWithNull(
        merge(
          commonDataLayer,
          {
            countryCode: appContext.country,
            countryLanguage: appContext.language,
            environment: appConfig.get('tracking.environment'),
            user: {
              connectionStatus: userStatus(appContext),
              neolaneID:
                appContext.neolaneId ||
                get(cookie, 'neolaneId', null) ||
                (appContext.isCxo && appContext.customerNeolaneId),
              visitorGUID: appContext.googleTrackingId,
            },
          },
          {
            siteType: appContext.isCxo ? SITE_B2B : SITE_B2C,
            event: data.event,
          },
          data.event !== EVENT_GA && appContext.isSeller && !appContext.isCmta
            ? appContext.cxoQueryParams
            : {},
          appContext.isCmta
            ? {
                agent: appContext.cmta.agent,
                agence: appContext.cmta?.agency?.toUpperCase(),
                searchType: appContext.cmta.searchType,
                userType: 'indirect',
              }
            : {},
        ),
      ),
    );
  }
}
export const setGoogleDataLayer = (
  payload: TrackPayload | null | undefined,
  referrerKey: string | null | undefined,
) => {
  // adding merge to have event first in the object
  googleDataLayer.set(
    replaceUndefinedWithNull(
      merge(
        {
          event: payload?.event,
        },
        payload,
      ),
    ),
    referrerKey,
  );
};
